// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";
import * as Subsonic__ApiError from "./apiError.jsx";
import * as Subsonic__Response from "./response.jsx";

function body_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.status;
  let tmp;
  if (v !== undefined) {
    const tag = Ppx_deriving_json_runtime.Primitives.string_of_json(v);
    tmp = tag === "failed" ? "failed" : Ppx_deriving_json_runtime.of_json_error("invalid JSON");
  } else {
    tmp = Ppx_deriving_json_runtime.of_json_error("missing field \"status\"");
  }
  const v$1 = x.error;
  return {
    status: tmp,
    error: v$1 !== undefined ? Subsonic__ApiError.of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"error\"")
  };
}

function body_to_json(x) {
  return {
    status: "failed",
    error: Subsonic__ApiError.to_json(x.error)
  };
}

function of_json(x) {
  return Subsonic__Response.of_json(body_of_json, x);
}

function to_json(x) {
  return Subsonic__Response.to_json(body_to_json, x);
}

export {
  body_of_json,
  body_to_json,
  of_json,
  to_json,
}
/* No side effect */
